@if (bskTypeMail === true && infosMailDisplay !== null) {
  <div class="col-12">
    <p-divider align="center">
      <span class="p-tag">{{'Mail_Info' | translate}}</span>
    </p-divider>
    @if (visuMode === true) {
      <div class="posmail">
          <div class="flex-grow mailcenter">
                <span class="badge" [ngClass]="{
                    grey: infosMailDisplay.mailAction === 0,
                    green: infosMailDisplay.mailAction === 1,
                    orange: infosMailDisplay.mailAction === 2,
                    purple: infosMailDisplay.mailAction === 3,
                    blue: infosMailDisplay.mailAction === 4
                }"
              >
              {{ infosMailDisplay.mailActionLabel }}
            </span>
          </div>
          <div class="flex-grow mailcenter">
            @if (infosMailDisplay.status === '') {
              <div>{{'Mail_NoState' | translate}}</div>
            }@else {
              <div>{{'Mail_State' | translate}}  {{ infosMailDisplay.status }}</div>
            }
          </div>
          <div class="flex-grow mailcenter">
            @if (infosMailDisplay.mailLimit) {
              <div>
                {{'Mail_DateL' | translate}} : {{ infosMailDisplay.dateLimit | date: 'shortDate' }}
              </div>
            }@else {
              <div>{{'Mail_NoDate' | translate}}</div>
            }
          </div>
      </div>
    }@else {
      <div class="posmail">
            <div class="flex-grow mailcenter">
              <p-inplace (onActivate)="startEditMail()"
                [active]="showEditMail">
                <ng-template pTemplate="display">
                  <span class="badge" [ngClass]="{
                      grey: infosMailDisplay.mailAction === 0,
                      green: infosMailDisplay.mailAction === 1,
                      orange: infosMailDisplay.mailAction === 2,
                      purple: infosMailDisplay.mailAction === 3,
                      blue: infosMailDisplay.mailAction === 4
                    }">
                    {{ infosMailDisplay.mailActionLabel }}
                  </span>
                </ng-template>
                <ng-template pTemplate="content">
                  <span class="p-float-label">
                    <p-dropdown [options]="actionMail" [(ngModel)]="infosMailDisplay.mailAction"
                      [showClear]="false" (ngModelChange)="refreshMailInfo()" panelStyleClass="mail-tag"
                      appendTo="body">
                      <ng-template pTemplate="selectedItem">
                        <span class="badge" [ngClass]="{
                          grey: infosMailDisplay.mailAction === 0,
                          green: infosMailDisplay.mailAction === 1,
                          orange: infosMailDisplay.mailAction === 2,
                          purple: infosMailDisplay.mailAction === 3,
                          blue: infosMailDisplay.mailAction === 4 }">
                          {{ infosMailDisplay.mailActionLabel }}
                        </span>
                      </ng-template>
                      <ng-template let-action pTemplate="item">
                        <div>
                          <span class="badge"  [ngClass]="{
                              grey: action.value === 0,
                              green: action.value === 1,
                              orange: action.value === 2,
                              purple: action.value === 3,
                              blue: action.value === 4 }">
                            {{ action.label }}
                          </span>
                        </div>
                      </ng-template>
                    </p-dropdown>
                  </span>
                </ng-template>
              </p-inplace>
            </div>
            <div class="flex-grow mailcenter">
              <p-inplace (onActivate)="startEditMail()"
                [active]="showEditMail">
                <ng-template pTemplate="display">
                  @if (infosMailDisplay.status === '') {
                    <div>{{'Mail_NoState' | translate}}</div>
                  }@else {
                    <div>{{'Mail_State' | translate}} {{ infosMailDisplay.status }}</div>
                  }
                </ng-template>
                <ng-template pTemplate="content">
                  <span class="p-float-label">
                    <input type="text" id="inputtext" pInputText [(ngModel)]="infosMailDisplay.status">
                    <label for="inputtext">{{'Mail_State_1' | translate}}</label>
                  </span>
                </ng-template>
              </p-inplace>
            </div>
            <div class="flex-grow mailcenter">
              <p-inplace (onActivate)="startEditMail()"
                [active]="showEditMail">
                <ng-template pTemplate="display">
                  @if (infosMailDisplay.mailLimit) {
                    <div>
                      {{'Mail_DateL' | translate}} : {{ infosMailDisplay.dateLimit | date: 'shortDate' }}
                    </div>
                  }@else {
                    <div>{{'Mail_NoDate' | translate}}</div>
                  }
                </ng-template>
                <ng-template pTemplate="content">
                  <span class="p-float-label">
                    <p-calendar monthNavigator="true" yearNavigator="true" showButtonBar="true" yearRange="2000:2050"
                                  inputId="dateLimit" [(ngModel)]="infosMailDisplay.dateLimit" dateFormat="dd/mm/yy"
                      (onFocus)="mailInfoChange()"
                      appendTo="body">
                    </p-calendar>
                    <label for="dateLimit">{{'Mail_DateL_1' | translate}}</label>
                  </span>
                </ng-template>
              </p-inplace>
            </div>
        <div class="mailcenter">
          @if (!showEditMail) {
            @switch(infosMailDisplay.mailDelay) {              
              @case (1) {
                <i class="icons8-clock size-ico" pTooltip="{{'&bsk_delay' | translate}}"></i>
              }
              @case (2) {
                <i class="icons8-clock size-ico clock-green" pTooltip="{{'&bsk_delay' | translate}}"></i>
              }
              @case (3) {
                <i class="icons8-clock size-ico clock-yellow" pTooltip="{{'&bsk_delay' | translate}}"></i>
              }
              @case (4) {
                <i class="icons8-clock size-ico clock-red" pTooltip="{{'&bsk_delay' | translate}}"></i>
              }
            }
              @if (infosMailDisplay.mailUrgent) {
                <i class="icons8-haute-priorit- size-ico font-red" pTooltip="{{'&bsk_mailurgent' | translate}}"></i>
              }
              @if (infosMailDisplay.mailConf) {
                <i class="icons8-confidentialit--du-courrier size-ico" pTooltip="{{'&bsk_mailconf' | translate}}"></i>
              }
          }@else {
              <div class="flex-grow mailcenter">
                  <p-inputSwitch [(ngModel)]="infosMailDisplay.mailUrgent"></p-inputSwitch>
                  <div>{{'Mail_Urg' | translate}}</div>
              </div>
              <div class="flex-grow mailcenter">
                  <p-inputSwitch [(ngModel)]="infosMailDisplay.mailConf"></p-inputSwitch>
                  <div>{{'Mail_Conf' | translate}}</div>
              </div>
              <div class="flex-grow mailcenter">
                  <p-inputSwitch [(ngModel)]="infosMailDisplay.mailLimit"></p-inputSwitch>
                  <div>{{'Mail_DateL_1' | translate}}</div>
              </div>
          }
        </div>
        @if (!editMode) {          
            @if (!showEditMail) {
              <div class="flex-grow mailcenter">
                <p-button class="mail-btn lg:mail-btn" icon="pi pi-pencil"
                  styleClass="p-button-filled" (onClick)="startEditMail()">
                </p-button>
              </div>
            }@else {
              <div class="flex-grow mailcenter">
                <p-button icon="pi pi-save" iconPos="left"
                  styleClass="p-button-filled mail-btn lg:mail-btn" (onClick)="clickSaveMail($event)">
                </p-button>
                <p-button icon="pi pi-times" iconPos="left"
                  styleClass="p-button-filled mail-btn" (onClick)="clickCancelMail()">
                </p-button>
              </div>
            }
        }
      </div>
    }
  </div>
}
